import {SET} from './constants';

export const set = (data = {}) => ({
  type: SET,
  data,
});
